import { SubmissionState } from '../interface/SubmissionInterface'

export default function (state: SubmissionState = {  }, action) {
    let propertyName: string;
    switch (action.type) {
        case "UPLOAD_NOT_STARTED":
            var newState = Object.assign({}, state);
            newState["fileStatus"] = action.payload;
            return newState;

        case "UPLOAD_STARTED":
            var newState = Object.assign({}, state);
            newState["fileStatus"] = action.payload.fileStatus;
            newState["StepsCompleted"] = action.payload.StepsCompleted;
            return newState;
            
        case "UPLOAD_COMPLETE":
            propertyName = "fileStatus";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "FILE_FORMAT_ERROR":
            propertyName = "fileStatus";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "COLUMN_MISMATCH":
            propertyName = "fileStatus";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SUBMISSION_ID":
            propertyName = "SubmissionID";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "FILE_NAME_STAMPED":
            propertyName = "FileNameStamped";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SUBMISSION_HISTORY":
            propertyName = "SubmissionFileHistory";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "CSV_SUMMARY_PRE":
            propertyName = "FileSummaryOutput_Pre";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "REMOVE_DUPES":
            return state;
        case "REMOVE_DUPES_b":
            return state;
        case "DUPES_SUMMARY":
            propertyName = "DupesSummaryOutput";

            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            newState["StepsCompleted"] = newState["StepsCompleted"] + 1;

            return newState;
        
        case "DUPES_SUMMARY_b":
            propertyName = "DupesSummaryOutput_b";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            newState["StepsCompleted"] = newState["StepsCompleted"] + 1;
            return newState;

        case "ABV_EXPANSION":
            return state;

        case "ABV_EXPANSION_SUMMARY":
            propertyName = "AbvOutput";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            newState["StepsCompleted"] = newState["StepsCompleted"] + 1;

            return newState;

        case "FIX_SPENDING":
            return state;

        case "FIX_SPENDING_SUMMARY":
            propertyName = "FixSpendingOutput";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            newState["StepsCompleted"] = newState["StepsCompleted"] + 1;

            return newState;

        case "TRUNCATION_SUMMARY":
            propertyName = "TruncationOutput";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            newState["StepsCompleted"] = newState["StepsCompleted"] + 1;

            return newState;
         
        case "CSV_SUMMARY_POST":
            propertyName = "FileSummaryOutput_Post";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            //console.log("post");
            //console.log(newState);
            return newState;
        case "PROCESSING_STARTED":
            var newState = Object.assign({}, state);
            newState["fileStatus"] = action.payload;

            return newState;
        case "DONE":
            var newState = Object.assign({}, state);
            newState["fileStatus"] = action.payload;

            newState["StepsCompleted"] = 0;
            //console.log("done");
            //console.log(newState);

            return newState;
        case "CANCELLED":
            var newState = Object.assign({}, state);
            newState["fileStatus"] = action.payload;
            //console.log(newState);
            newState["StepsCompleted"] = 0;
            return newState;
        case "CONFIRMED":
            var newState = Object.assign({}, state);
            newState["fileStatus"] = action.payload;

            return newState;
        case "SUBMISSION_DETAIL":
            return state;

        case "DOWNLOAD":
            return state;

        default:
            return state;
    }
}